import createYearTabsListingView from '../PeriodTabs/createYearTabsListingView';
import FlexVideoCard from './FlexVideoCard';

export default createYearTabsListingView(FlexVideoCard, {
  displayName: 'VideoYearTabsView',
  containerClass: '',
  supportsGrid: true,
  hideLinkByDefault: false,
});
